import { Switch } from "@/components/ui/switch";
import { SubBadge } from "@/components/admin/SectionShell";
import { GuideEffectPreview } from "../GuideEffectPreview";
import { SectionCard } from "../SectionShell";
import { inputCls, SelectField, TextField, ToggleRow } from "./Fields";

const LABELS = [
  ["guides_back_label", "Back button label"],
  ["guides_page_label", "Small label above title"],
  ["guides_page_title", "Main page title"],
  ["guides_count_singular", "Count label (singular)"],
  ["guides_count_plural", "Count label (plural)"],
  ["guides_loading_text", "Loading text"],
  ["guides_empty_title", "Empty state title"],
  ["guides_empty_text", "Empty state text"],
];

export const GuidesSettings = ({ content, setC, toggleContentFlag }) => (
  <SectionCard id="guides" testId="guides-page-content-editor" className="mb-4">
    <ToggleRow testId="toggle-guides_visible" label="Guides" sub="Tab + public guides page" checked={!!content.guides_visible} onChange={(v) => toggleContentFlag("guides_visible", v)} className="mb-5" />
    <p className="font-medium mb-4">Guides page content</p>
    <div className="grid lg:grid-cols-[1fr_auto] gap-5 mb-4">
      <div className="grid md:grid-cols-2 gap-4">
        <SelectField k="guides_card_effect" label="Card visual effect" value={content.guides_card_effect || "cinematic"} onChange={(v) => setC("guides_card_effect", v)}
          options={[["cinematic", "Cinematic Reveal"], ["glass", "Floating Glass Cards"], ["spotlight", "Interactive Spotlight"], ["masonry", "Editorial Masonry"], ["tilt", "3D Tilt Cards"]]} />
        <SelectField k="guides_sort" label="Display order" value={content.guides_sort || "manual"} onChange={(v) => setC("guides_sort", v)}
          options={[["manual", "Manual (drag order)"], ["name_asc", "Name A → Z"], ["name_desc", "Name Z → A"], ["random", "Random shuffle (every visit)"]]} />
        <SelectField k="guides_photo_size" label="Photo size" value={content.guides_photo_size || "classic"} onChange={(v) => setC("guides_photo_size", v)}
          options={[["compact", "Compact (many small photos)"], ["classic", "Classic (current)"], ["tall", "Tall portraits"], ["large", "Large photos"], ["wide", "Wide photos"]]} />
        <div className="flex items-end justify-between rounded-xl border border-border bg-white/50 px-4 py-3">
          <div>
            <p className="text-sm font-medium"><SubBadge /> Enable visual effects</p>
            <p className="text-xs text-muted-foreground">Turns entrance, hover, spotlight, masonry, and tilt motion on/off.</p>
          </div>
          <Switch data-testid="content-guides_effects_enabled" aria-label="Toggle guide visual effects" checked={content.guides_effects_enabled !== false} onCheckedChange={(v) => setC("guides_effects_enabled", v)} />
        </div>
      </div>
      <GuideEffectPreview content={content} />
    </div>
    <div className="grid md:grid-cols-2 gap-4">
      {LABELS.map(([k, label]) => <TextField key={k} k={k} label={label} content={content} setC={setC} />)}
      <div className="md:col-span-2 flex items-center justify-between rounded-xl border border-border bg-white/50 px-4 py-3">
        <div>
          <p className="text-sm font-medium"><SubBadge /> Show guides count</p>
          <p className="text-xs text-muted-foreground">Shows/hides the live count line (e.g. "20 guides") on the public Guides page.</p>
        </div>
        <Switch data-testid="content-guides_count_visible" aria-label="Toggle guides count line" checked={!!content.guides_count_visible} onCheckedChange={(v) => setC("guides_count_visible", v)} />
      </div>
      <div className="md:col-span-2">
        <label className="text-xs uppercase tracking-widest text-muted-foreground">Thank-you message at top</label>
        <textarea data-testid="content-guides_page_message" rows={4} value={content.guides_page_message || ""} onChange={(e) => setC("guides_page_message", e.target.value)} className={`${inputCls} resize-y`} />
      </div>
    </div>
  </SectionCard>
);
